import React from "react";
import { colors } from "../utils/profileStyles";

export default function ProfileFeedbackAlert({ message }) {
  if (!message?.text) return null;

  return (
    <div
      style={{
        marginBottom: 12,
        background: message.type === "success" ? colors.successBg : colors.errorBg,
        border: `1px solid ${
          message.type === "success" ? colors.successBorder : colors.errorBorder
        }`,
        color: message.type === "success" ? colors.successText : colors.errorText,
        borderRadius: 14,
        padding: "11px 12px",
        fontFamily: "Montserrat, sans-serif",
        fontSize: "12px",
        lineHeight: "17px",
        fontWeight: 600,
      }}
    >
      {message.text}
    </div>
  );
}
